/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query PressQuery($uid: String!) {
    prismic {
      press(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_PressBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Press = ({ data, location }) =>
  data.prismic.press ? (
    <MainLayout location={location} layout='press'>
    <Helmet>
      <title>{(data.prismic.press.title[0] && data.prismic.press.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.press.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.press.path : 'https://www.digitalocean.com' + data.prismic.press.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.press.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.press.title[0] ? data.prismic.press.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.press.description ? data.prismic.press.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.press.open_graph_image ? data.prismic.press.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.press.description ? data.prismic.press.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.press.title[0] ? data.prismic.press.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.press.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.press.path : 'https://www.digitalocean.com' + data.prismic.press.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.press.open_graph_image ? data.prismic.press.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.press.body} />
    </MainLayout>
  ) : null;

Press.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Press;
